import { useEffect, useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { EventStatus } from 'routes/referral/types/event-detail-api.types';

import { getStatusColor } from '../utils';

type StatusBadgeProps = {
  status: EventStatus;
};

const getStatusText = (status: EventStatus): string => {
  switch (status) {
    case EventStatus.FINISHED:
      return 'finished';
    case EventStatus.REWARDS_DISTRIBUTED:
      return 'reward distribution';
    case EventStatus.ONGOING:
      return 'ongoing';
    case EventStatus.REGISTRATION_OPEN:
      return 'registration open';
    case EventStatus.UPCOMING:
      return 'upcoming';
  }
};

export const StatusBadge = ({ status }: StatusBadgeProps) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [fontSize, setFontSize] = useState<'tw-text-[12px]' | 'tw-text-[10px]'>('tw-text-[12px]');

  const backgroundColor = getStatusColor(status).color;
  const text = getStatusText(status);

  useEffect(() => {
    const checkTextOverflow = () => {
      if (textRef.current) {
        const element = textRef.current;
        const isOverflowing = element.scrollWidth > element.clientWidth;
        setFontSize(isOverflowing ? 'tw-text-[10px]' : 'tw-text-[12px]');
      }
    };

    checkTextOverflow();
    window.addEventListener('resize', checkTextOverflow);

    return () => {
      window.removeEventListener('resize', checkTextOverflow);
    };
  }, [text]);

  return (
    <div
      className={twMerge(
        'tw-flex tw-h-[26px] tw-w-fit tw-items-center tw-rounded-[50px] tw-p-[10px] tw-font-jost tw-font-semibold tw-uppercase',
        fontSize
      )}
      style={{ backgroundColor }}
    >
      <span ref={textRef} className="tw-whitespace-nowrap tw-leading-normal">
        {text}
      </span>
    </div>
  );
};
